import { Component } from '@angular/core';

@Component({
  selector: 'app-file-upload-logo',
  imports: [],
  template: `
    <svg
      width="25"
      height="32"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#043B22"
        d="M480 136h-16v-24c0-13.3-10.7-24-24-24H237.3L195.3 56H80c-13.3 0-24 10.7-24 24v56H32c-17.7 0-32 14.3-32 32v264c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V168c0-17.7-14.3-32-32-32zM80 80h107.3l42 32H456v24H80V80zm400 352H32V168h448v264z"
      />
      <path
        fill="#043B22"
        d="M256 200c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 192c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
      />
      <path fill="#043B22" d="M272 320h24l-40-40-40 40h24v32h32v-32z" />
    </svg>
  `
})
export class fileUploadlogoComponent {}
